module.exports = __webpack_public_path__ + "static/img/michikusa.892a3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/michikusa.png
// module id = PGzd
// module chunks = 1